import { Avatar, AvatarProps, Box, BoxProps } from '@mui/material';
import { ReactNode } from 'react';

interface IUserAccount {
  avatarProps?: AvatarProps;
  boxProps?: BoxProps;
  children: ReactNode;
}

export const UserAccount = ({ avatarProps, boxProps, children }: IUserAccount) => (
  <Box {...boxProps}>
    <Avatar {...avatarProps} />
    {children}
  </Box>
);
